export const friendlyErrorMapping = {
  USER_NOT_FOUND: '用户名不存在',
  INVALID_PASSWORD: '密码不正确',
  USER_ALREADY_EXIST: '用户已注册',
  INVALID_CREDENTIAL: '请先登录',
  INTERNAL_ERROR: '服务器错误，请稍后重试',
};
